let timeout = null;

const init = () => {
  const closeBtn = document.querySelector('.b-toast__close-btn');

  closeBtn.addEventListener('click', () => {
    hideToast();
  });
};

export const showToast = (msg, type) => {
  const toastEl = document.querySelector('.b-toast');
  const messageEl = document.querySelector('.b-toast__message');

  messageEl.innerText = msg;
  toastEl.classList.add('shown');
  toastEl.classList.add(type);

  if (timeout !== null) {
    clearTimeout(timeout);
    timeout = null;
  }

  timeout = setTimeout(() => {
    toastEl.classList.remove('shown');
    timeout = null;
  }, 10000);
};

export const hideToast = () => {
  const toastEl = document.querySelector('.b-toast');

  toastEl.classList.remove('shown');

  if (timeout !== null) {
    clearTimeout(timeout);
    timeout = null;
  }
};

export const isToastActive = () => {
  return !!timeout;
};

export default {init};
